var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"error_wrap"},[_c('div',{staticClass:"error_inner"},[_c('p',[_vm._v("ERROR")]),_vm._v(" "),_c('span',[_vm._v("Not Found"),_c('br'),_vm._v("Please contact support@bwisesoft.com")]),_vm._v(" "),_c('a',{staticClass:"normal_bt error_home_bt",attrs:{"href":"javascript:;","onClick":"history.go(-1);"}},[_vm._v("To previous page")])])])
}]

export { render, staticRenderFns }